import React, { useState } from "react";
import { Edit, Plus, Trash, ChevronDown, ChevronRight } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

const fieldsOrder = [
    { key: "QuantityMP", label: "Cantitate MP" },
    { key: "QuantityML", label: "Cantitate ML" },
    { key: "QuantityBUC", label: "Bucăți" },
    { key: "Length", label: "Lungime (mm)" },
    { key: "Width", label: "Lățime (mm)" },
    { key: "Quantity", label: "Nr. bucăți" },
    { key: "UnitPrice", label: "Preț unitar" },
    { key: "AcquisitionPrice", label: "Preț achiziție" },
    { key: "Bizot", label: "Bizot" },
];

const fieldsOffer = [
    { key: "QuantityMP", label: "Cantitate MP" },
    { key: "QuantityML", label: "Cantitate ML" },
    { key: "QuantityBUC", label: "Bucăți" },
    { key: "Length", label: "Lungime (mm)" },
    { key: "Width", label: "Lățime (mm)" },
    { key: "Quantity", label: "Nr. bucăți" },
    { key: "UnitPrice", label: "Preț unitar" },
    { key: "Bizot", label: "Bizot" },
];

const AuditOrderItemsDiff = ({ oldItems, newItems, onItemOpen, isOffer }) => {
    const { darkMode } = useTheme();
    const [open, setOpen] = useState({}); // === termék-accordion nyitva/zárva

    const fields = isOffer ? fieldsOffer : fieldsOrder;

    const toggle = (name) => {
        setOpen((prev) => ({
            ...prev,
            [name]: !prev[name],
        }));
    };

    const oldMap = {};
    const newMap = {};

    oldItems.forEach((i) => (oldMap[i.MaterialName] = i));
    newItems.forEach((i) => (newMap[i.MaterialName] = i));

    const names = [...new Set([
        ...oldItems.map((i) => i.MaterialName),
        ...newItems.map((i) => i.MaterialName),
    ])];

    const cellClasses = {
        label: "p-2 font-semibold w-[40%] min-w-[180px] text-left",
        old: "p-2 text-red-500 w-[35%] min-w-[200px] break-all text-left",
        new: "p-2 text-green-600 w-[25%] min-w-[200px] break-all text-left",
    };

    const tableHead = (
        <thead>
            <tr className={`${darkMode ? "bg-gray-700 text-white" : "bg-gray-200 text-black"}`}>
                <th className="p-2 text-left w-[40%]">Câmp</th>
                <th className="p-2 text-left w-[35%]">Vechi</th>
                <th className="p-2 text-left w-[25%]">Nou</th>
            </tr>
        </thead>
    );

    return (
        <div className="space-y-6">
            {names.map((name) => {
                const A = oldMap[name];
                const B = newMap[name];

                const deleted = A && !B;
                const added = !A && B;

                const changed = (!deleted && !added)
                    ? fields.filter((f) => A[f.key] !== B[f.key])
                    : [];

                const isChangedBlock = deleted || added || changed.length > 0;
                if (!isChangedBlock) return null;

                // ikon + szín
                let labelColor = "text-yellow-600";
                let labelIcon = <Edit size={18} />;

                if (deleted) {
                    labelColor = "text-red-600";
                    labelIcon = <Trash size={18} />;
                }
                if (added) {
                    labelColor = "text-green-600";
                    labelIcon = <Plus size={18} />;
                }

                return (
                    <div key={name}
                        className={`border rounded-lg ${darkMode ? "border-gray-700 bg-gray-800" : "border-gray-300 bg-gray-50"}`}
                    >
                        {/* HEADER - kinyitható */}
                        <div
                            onClick={() => {
                                toggle(name);
                                if (!open[name] && onItemOpen) {
                                    onItemOpen(); // 👉 scroll to items
                                }
                            }}
                            className="cursor-pointer flex justify-between items-center px-4 py-2"
                        >
                            <div className={`font-bold flex gap-2 items-center ${labelColor}`}>
                                {labelIcon} {deleted ? "Produs șters" : added ? "Produs adăugat" : "Modificat"}: {name}
                            </div>

                            {open[name] ? (
                                <ChevronDown className="text-gray-500" />
                            ) : (
                                <ChevronRight className="text-gray-500" />
                            )}
                        </div>

                        {/* BODY - csak ha nyitva van */}
                        {open[name] && (
                            <div className="px-4 pb-4">
                                <table className={`w-full text-sm border mt-3 ${darkMode ? "border-gray-700" : "border-gray-300"}`}>
                                    {tableHead}
                                    <tbody>
                                        {(deleted || added ? fields : changed).map((f) => (
                                            <tr key={f.key}
                                                className={`${darkMode ? "border-gray-700" : "border-gray-300"} border-t`}
                                            >
                                                <td className={cellClasses.label}>{f.label}</td>

                                                <td className={cellClasses.old}>
                                                    {deleted ? A[f.key] ?? "—" : A?.[f.key] ?? "—"}
                                                </td>

                                                <td className={cellClasses.new}>
                                                    {added ? B[f.key] ?? "—" : B?.[f.key] ?? "—"}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default AuditOrderItemsDiff;
